import { YearViewCell } from "../types";
import { modifyDate } from "../utils";

/**
 * * Сгенерировать ячейки YearViewCell
 * @param firstYear Первый год в списке
 * @returns
 */
export const generateYearViewCell = (firstYear: number): YearViewCell[] => {
  return Array.from({ length: 12 }, (_, index) => ({
    year: index + firstYear,
    text: (index + firstYear).toString(),
    isCurrent: modifyDate(new Date(index + firstYear, 0, 1)).isCurrentYear(),
  }));
};
